var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42 9.99999C6.28441 10.002 6.15408 9.94765 6.06 9.84999L5.86 9.64999C5.76534 9.55611 5.7121 9.42831 5.7121 9.29499C5.7121 9.16167 5.76534 9.03388 5.86 8.93999L11.65 3.14999C11.7407 3.05332 11.8674 2.99847 12 2.99847C12.1326 2.99847 12.2593 3.05332 12.35 3.14999L18.14 8.93999C18.2347 9.03388 18.2879 9.16167 18.2879 9.29499C18.2879 9.42831 18.2347 9.55611 18.14 9.64999L17.94 9.84999C17.8459 9.94765 17.7156 10.002 17.58 9.99999L15 9.99999L15 15.5C15 15.7761 14.7761 16 14.5 16L9.5 16C9.22386 16 9 15.7761 9 15.5L9 9.99999H6.42ZM19 19.5V18.5C19 18.2239 18.7761 18 18.5 18H5.5C5.22386 18 5 18.2239 5 18.5L5 19.5C5 19.7761 5.22386 20 5.5 20H18.5C18.7761 20 19 19.7761 19 19.5Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Upload.7861936a.svg";
export { ForwardRef as ReactComponent };